import React from "react";
import { resolveIsoCountrySelectValue } from "../../../../utils/iso3166Alpha2Options";

export function emptyOrText(value) {
  const s = value != null && String(value).trim() !== "" ? String(value).trim() : "";
  if (!s) {
    return <span className="partner-details-overview__empty">Not set</span>;
  }
  return s;
}

/** Display label for stored country (ISO code or legacy free text). */
export function formatCountryForDisplay(raw) {
  if (raw == null || String(raw).trim() === "") return null;
  const resolved = resolveIsoCountrySelectValue(raw);
  return resolved?.label || String(raw).trim();
}

export function dialPhoneParts(countryCode, phone) {
  const code =
    countryCode != null && String(countryCode).trim() !== ""
      ? String(countryCode).replace(/^\+/g, "").replace(/\D/g, "")
      : "";
  let local = phone != null ? String(phone).trim() : "";
  local = local.replace(/^\++/g, "").trim();
  if (!code && !local) {
    return { display: null, telHref: null };
  }
  const display = code ? `+${code} ${local}`.trim() : local || null;
  const digits = `${code}${local.replace(/\D/g, "")}`;
  const telHref = digits ? `tel:+${digits.replace(/^\+/, "")}` : null;
  return { display, telHref };
}
